<script>
import Reward from '@/components/Reward/index.vue'
import { delList, getList, updateCfg } from '@/api/config/free-reward-cfg'

export default {
  name: 'FreeReward',
  components: { Reward },
  data() {
    return {
      typeArr: [{ label: 'coinMaster', value: 'coinMaster' }, { label: 'monopoly', value: 'monopoly' }],
      curClass: 'coinMaster',
      tableData: [{ date: '2025-08', show: 1, send_time: '2025-08-02 18:40:01', link: 'https://rewards.coinmaster.com/rewards/rewards.html?c=pe_RICHElzHfo_20250720', reward: [{ 'num': 60, 'skin': 0, 'propsId': 15 }] }]
    }
  },
  created() {
    this.getTable()
  },
  methods: {
    getTable() {
      this.tableData = []
      getList({ name: this.curClass }).then(res => {
        this.tableData = res.data
      })
    },
    updateTable() {
      updateCfg({ data: JSON.stringify(this.tableData) }).then(res => {
        this.msgSuccess(res.msg)
      })
    },
    del(id) {
      this.$confirm('是否确认删除数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delList({ id: id }).then(res => {
          this.msgSuccess('删除成功')
          this.getTable()
        })
      })
    },
    handleTabClick(val) {
      this.curClass = val.name
      this.getTable()
    }
  }
}
</script>

<template>
  <el-card>
    <el-tabs v-model="curClass" tab-position="left" style="background-color: #ffffff;height: 800px;overflow: auto" @tab-click="handleTabClick">
      <el-tab-pane v-for="(item, index) in typeArr" :key="index" :label="item.label" :name="item.value">
        <el-table
          :data="tableData"
          style="width: 100%"
          border
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
          />
          <el-table-column
            prop="send_time"
            label="发布日期"
            align="center"
          />
          <el-table-column
            label="链接"
            align="center"
          >
            <template v-slot:default="{row}">
              <el-input v-model="row.link" placeholder="链接" />
            </template>
          </el-table-column>
          <el-table-column
            label="奖励"
            align="center"
          >
            <template v-slot:default="{row}">
              <Reward :value="row.reward" :read-only="true" />
            </template>
          </el-table-column>
          <el-table-column
            label="显示/隐藏"
            align="center"
          >
            <template v-slot:default="{row}">
              <el-switch
                v-model.number="row.show"
                style="display: block"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="显示"
                inactive-text="隐藏"
                :active-value="1"
                :inactive-value="0"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template v-slot:default="{row}">
              <el-button type="danger" size="mini" @click="del(row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <div style="width: 100%;margin-top: 20px;text-align: center">
        <el-button type="primary" style="text-align: center" size="mini" @click="updateTable()">保存</el-button>
      </div>
    </el-tabs>
  </el-card>
</template>

<style scoped>

</style>
